import React from 'react'
import { Button, ClickAwayListener, Tooltip } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'

const CurrencyTooltip = ({ className, currency, exchange, header }) => {
  const [open, setOpen] = React.useState(false)

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const handleTooltipOpen = () => {
    setOpen(true)
  }
  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div className={className}>
        <Tooltip
          PopperProps={{
            disablePortal: true
          }}
          arrow
          placement={!!header ? 'top' : 'bottom'}
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={<><FormattedMessage id='Fields.label.currency'/>: <strong>{currency}</strong><br/><FormattedMessage
            id='Fields.label.exchangeRate'/>: <strong>{exchange} <FormattedMessage id='EGP'/></strong></>}
        >
          <Button color={'primary'} variant={'text'} onClick={handleTooltipOpen}><strong>{currency}</strong></Button>
        </Tooltip>
      </div>
    </ClickAwayListener>
  )
}

export default CurrencyTooltip
